export default __webpack_public_path__ + "static/media/auto-sync.8e574284.jpg";